// 组织架构接口
import request from '@/util/http';
export default {
    orgListSearch,   // 组织架构查询
    orgApiGetorg,     //根据公司id查询下面所有人员
    orgApiAddorupda,  //新增修改组织架构
    orgApiDelorg,     //删除组织架构
    orgApiOrguser,    //组织架构人名称搜索
    orgApiGetorgnetall,    //根据组织架构ID查询下面所有人
    updateorgbygoodsnum,    //修改组织架构对应商品数量
    putinorg,    //加入组织架构
    addorupdatecupgoodsbyorg, //从标准库添加商品/修改价格分类 含组织架构
    getgoodslistbyorg,  //商品列表 显示组织架构
    adduserbycode,   //添加员工-带员工编号
    updateMoibleAndCode,  //修改用户手机号和员工编号
    userlistbycode,    //用户列表查询 带员工编号
    exportscxrypz,    //导出生产线人员配置表
    exportghmx,    //导出归还明细表
    exportlymx,    //导出领取明细表
    exportwghmx, //导出未归还明细表
    exportdjbom, //导出刀具BOM表
    orgbycompany, //根据公司id查询组织架构
    addorupdatecupgoodsdetail, //商品详情新增修改
    deletecupgoodsdetail, //删除商品详情
    uploaddjbom,  //导入刀具bom表
    updateuserinfo, //修改用户信息
    putoutorg, //退出组织架构
}
function putoutorg(data) {
  return request({
    url: "/org/api/putoutorg",
    method: 'post',
    data,
  })
}

function updateuserinfo(data) {
  return request({
    url: "/user/api/updateuserinfo",
    method: 'post',
    data,
  })
}

function uploaddjbom(data) {
  return request({
    url: "/load/excel/api/uploaddjbom",
    method: 'post',
    data,
  })
}

function deletecupgoodsdetail(data) {
  return request({
    url: "devicecabinet/api/deletecupgoodsdetail",
    method: 'post',
    data,
  })
}

function addorupdatecupgoodsdetail(data) {
  return request({
    url: "devicecabinet/api/addorupdatecupgoodsdetail",
    method: 'post',
    data,
  })
}

function orgbycompany(data) {
  return request({
    url: "org/api/orgbycompany",
    method: 'post',
    data,
  })
}

function exportdjbom(data) {
  return request({
    url: "excel/api/exportdjbom",
    method: 'post',
    data,
    responseType: 'blob'
  })
}

function exportwghmx(data) {
  return request({
    url: "excel/api/exportwghmx",
    method: 'post',
    data,
    responseType: 'blob'
  })
}

function exportlymx(data) {
  return request({
    url: "excel/api/exportlymx",
    method: 'post',
    data,
    responseType: 'blob'
  })
}

function exportghmx(data) {
  return request({
    url: "excel/api/exportghmx",
    method: 'post',
    data,
    responseType: 'blob'
  })
}

function exportscxrypz(data) {
  return request({
    url: "excel/api/exportscxrypz",
    method: 'post',
    data,
    responseType: 'blob'
  })
}

function userlistbycode(data) {
    return request({
      url: "sys/api/userlistbycode",
      method: 'post',
      data
    })
}

function updateMoibleAndCode(data) {
    return request({
      url: "user/api/updateMoibleAndCode",
      method: 'post',
      data
    })
}

function adduserbycode(data) {
    return request({
      url: "user/api/adduserbycode",
      method: 'post',
      data
    })
}

function getgoodslistbyorg(data) {
    return request({
      url: "devicecabinet/api/getgoodslistbyorg",
      method: 'post',
      data
    })
}

function addorupdatecupgoodsbyorg(data) {
    return request({
      url: "devicecabinet/api/addorupdatecupgoodsbyorg",
      method: 'post',
      data
    })
}

function putinorg(data) {
    return request({
      url: "org/api/putinorg",
      method: 'post',
      data
    })
}

function updateorgbygoodsnum(data) {
    return request({
      url: "org/api/updateorgbygoodsnum",
      method: 'post',
      data
    })
}

function orgApiGetorgnetall(data) {
    return request({
      url: "org/api/getorgnetalluserlistbypage",
      method: 'post',
      data
    })
}

function orgApiOrguser(data) {
    return request({
      url: "org/api/orguserlistbypage",
      method: 'post',
      data
    })
}

function orgApiDelorg(data) {
    return request({
      url: "org/api/delorg",
      method: 'post',
      data
    })
}

function orgListSearch(data) {
    return request({
      url: "org/api/orglist",
      method: 'post',
      data
    })
}

function orgApiGetorg(data) {
    return request({
      url: "org/api/getorgnetalluserlistbycompany",
      method: 'post',
      data
    })
}

function orgApiAddorupda(data) {
    return request({
      url: "org/api/addorupdateorg",
      method: 'post',
      data
    })
}